var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileRtf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Canvas",
    transform: "translate(6567 -1382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__rtf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path0_fill",
    transform: "translate(-6567 1382)",
    fill: "#D9DEE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path1_fill",
    transform: "translate(-6557.4 1408.31)",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path2_fill",
    transform: "translate(-6557.4 1408.31)",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path3_fill",
    transform: "translate(-6557.4 1408.31)",
    fill: "#556080"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -6556 1397)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -6556 1399)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -6561 1401)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -6561 1403)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__T"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path7_fill",
    transform: "translate(-6561 1394)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-rtf_svg__file-rtf_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-rtf_svg__file-rtf_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -6556 1395)",
    fill: "#556080"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path0_fill",
    d: "M 20.7146 0L 2.07105 0C 0.928471 0 -3.14132e-09 0.8996 -3.14132e-09 2.0124L -3.14132e-09 33.9876C -3.14132e-09 35.0992 0.928471 36 2.07105 36L 26.929 36C 28.074 36 29 35.0992 29 33.9876L 29 8.0496L 20.7146 0ZM 20.7146 2.8452L 26.0717 8.0496L 20.7146 8.0496L 20.7146 2.8452ZM 26.9294 33.9876L 2.07105 33.9876L 2.07105 2.0124L 18.6431 2.0124L 18.6431 8.0496C 18.6431 9.1612 19.5695 10.062 20.7142 10.062L 26.929 10.062L 26.929 33.9876L 26.9294 33.9876Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path1_fill",
    d: "M 3.042 4.206C 3.082 4.27 3.102 4.336 3.102 4.404C 3.102 4.484 3.074 4.552 3.018 4.608C 2.966 4.66 2.894 4.686 2.802 4.686C 2.686 4.686 2.596 4.636 2.532 4.536L 1.5 2.88L 1.392 2.88L 0.624 2.88L 0.624 4.374C 0.624 4.462 0.594 4.536 0.534 4.596C 0.478 4.656 0.404 4.686 0.312 4.686C 0.224 4.686 0.15 4.656 0.09 4.596C 0.03 4.536 0 4.462 0 4.374L 0 0.312C 0 0.22 0.03 0.146 0.09 0.09C 0.15 0.03 0.224 0 0.312 0L 1.392 0C 1.688 0 1.952 0.062 2.184 0.186C 2.42 0.31 2.602 0.484 2.73 0.708C 2.862 0.932 2.928 1.188 2.928 1.476C 2.928 1.76 2.856 2.012 2.712 2.232C 2.568 2.452 2.372 2.618 2.124 2.73L 3.042 4.206ZM 1.392 2.304C 1.664 2.304 1.888 2.228 2.064 2.076C 2.24 1.92 2.328 1.72 2.328 1.476C 2.328 1.212 2.24 0.996 2.064 0.828C 1.888 0.66 1.664 0.576 1.392 0.576L 0.624 0.576L 0.624 2.304L 1.392 2.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path2_fill",
    d: "M 6.77902 0C 6.86302 0 6.93102 0.028 6.98302 0.084C 7.03902 0.136 7.06702 0.204 7.06702 0.288C 7.06702 0.372 7.03902 0.442 6.98302 0.498C 6.93102 0.55 6.86302 0.576 6.77902 0.576L 5.48902 0.576L 5.48902 4.374C 5.48902 4.462 5.45902 4.536 5.39902 4.596C 5.33902 4.656 5.26502 4.686 5.17702 4.686C 5.08902 4.686 5.01502 4.656 4.95502 4.596C 4.89502 4.536 4.86502 4.462 4.86502 4.374L 4.86502 0.576L 3.56902 0.576C 3.48502 0.576 3.41502 0.55 3.35902 0.498C 3.30702 0.442 3.28102 0.372 3.28102 0.288C 3.28102 0.204 3.30702 0.136 3.35902 0.084C 3.41502 0.028 3.48502 0 3.56902 0L 6.77902 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path3_fill",
    d: "M 7.69181 4.686C 7.60381 4.686 7.52981 4.656 7.46981 4.596C 7.40981 4.536 7.37981 4.462 7.37981 4.374L 7.37981 0.312C 7.37981 0.22 7.40981 0.146 7.46981 0.09C 7.52981 0.03 7.60381 0 7.69181 0L 10.4038 0C 10.4958 0 10.5698 0.028 10.6258 0.084C 10.6818 0.136 10.7098 0.206 10.7098 0.294C 10.7098 0.378 10.6818 0.446 10.6258 0.498C 10.5698 0.55 10.4958 0.576 10.4038 0.576L 8.00381 0.576L 8.00381 2.034L 9.72581 2.034C 9.81381 2.034 9.88581 2.062 9.94181 2.118C 10.0018 2.17 10.0318 2.238 10.0318 2.322C 10.0318 2.406 10.0018 2.476 9.94181 2.532C 9.88581 2.584 9.81381 2.61 9.72581 2.61L 8.00381 2.61L 8.00381 4.374C 8.00381 4.462 7.97381 4.536 7.91381 4.596C 7.85381 4.656 7.77981 4.686 7.69181 4.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path4_fill",
    d: "M 0 0L 11 0L 11 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path5_fill",
    d: "M 0 0L 16 0L 16 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path6_fill",
    d: "M 0 0L 12 0L 12 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-rtf_svg__file-rtf_svg__path7_fill",
    d: "M 4 0L 4 0.885346L 2.52261 0.885346L 2.52261 5L 1.48409 5L 1.48409 0.885346L 0 0.885346L 0 0L 4 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileRtf);
export default __webpack_public_path__ + "static/media/file-rtf.14fe8f614b8b26e4c87f562b176642ae.svg";
export { ForwardRef as ReactComponent };